"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelsGraph = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const lazyQueryHelper_1 = require("./lazyQueryHelper");
function getLabelsGraph(params) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        switch (params.item.subjectArea) {
            case 'column':
            case 'Column':
                return getColumnLineageLabels(params);
            case 'database':
            case 'CloudFile':
            case 'DatabaseServer':
            case 'File':
            case 'WebDataConnector':
            case 'DataCloud':
                return getDatabaseLineageLabels(params);
            case 'table':
            case 'DatabaseTable':
            case 'CalculatedInsight':
            case 'DataLake':
            case 'DataModel':
                return getDatabaseTableLineageLabels(params);
            case 'virtualConnectionTable':
            case 'VirtualConnectionTable':
                return getVirtualConnectionTableLineageLabels(params);
            case 'flow':
            case 'Flow':
                return getFlowLineageLabels(params);
            case 'datasource':
            case 'PublishedDatasource':
                return getPublishedDatasourceLineageLabels(params);
            case 'EmbeddedDatasource':
                return getEmbeddedDatasourceLineageLabels(params);
            case 'virtualConnection':
            case 'VirtualConnection':
                return getVirtualConnectionLineageLabels(params);
            case 'View':
                return getViewLineageLabels(params);
            case 'Workbook':
            case 'workbook':
                return getWorkbookLineageLabels(params);
            case 'Field':
                return getFieldLineageLabels(params);
            case 'FlowColumnOutputField':
                return getFlowColumnFieldLineageLabels(params);
            case 'FlowFieldOutputField':
                return getFlowFieldLineageLabels(params);
            case 'Metric':
            case 'metric':
                return Promise.reject('metrics are no longer in catalog');
            case undefined:
                return Promise.reject('subjectArea was not defined');
            default:
                (0, vizportalclient_common_components_1.assertUnreachable)(params.item.subjectArea);
                return Promise.reject('subjectArea was not defined');
        }
    });
}
exports.getLabelsGraph = getLabelsGraph;
function queryWithUpstream(client, query, variables) {
    var _a, _b, _c, _d, _e;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const first = yield client.query({ query, variables: Object.assign(Object.assign({}, variables), { excludeInherited: true }) });
        const includeInherted = ((_e = (_d = (_c = (_b = (_a = first === null || first === void 0 ? void 0 : first.data) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.upstreamLabels) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0;
        if (includeInherted) {
            return first;
        }
        return yield client.query({ query, variables: Object.assign(Object.assign({}, variables), { excludeInherited: false }) });
    });
}
function getColumnLineageLabels(_a) {
    var _b;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.ColumnLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { id: (_b = item.contentId) !== null && _b !== void 0 ? _b : null } });
        const upstreamLabels = data.items.flatMap(t => { var _a; return (_a = t.upstreamColumns) !== null && _a !== void 0 ? _a : []; }).flatMap(t => { var _a; return (_a = t === null || t === void 0 ? void 0 : t.labels) !== null && _a !== void 0 ? _a : []; });
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { upstreamLabels, item })));
    });
}
function getDatabaseLineageLabels(_a) {
    var _b, _c, _d;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.DatabaseLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null } });
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels: (_d = (_c = data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels })));
    });
}
function getDatabaseTableLineageLabels(_a) {
    var _b, _c, _d, _e, _f;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.DatabaseTableLineageLabelsDocument;
        const { loading, error, data } = yield queryWithUpstream(client, query, { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null });
        const upstreamLabels = (_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        const parentedItems = (_f = (_e = data === null || data === void 0 ? void 0 : data.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.columns;
        const inheritedByCandidates = parentedItems;
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels, parentedItems, inheritedByCandidates })));
    });
}
function getVirtualConnectionLineageLabels(_a) {
    var _b, _c, _d, _e, _f, _g;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.VirtualConnectionLineageLabelsDocument;
        const { loading, error, data } = yield queryWithUpstream(client, query, { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null });
        const upstreamLabels = (_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        const inheritedByCandidates = (_g = (_f = (_e = data.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.tables) === null || _g === void 0 ? void 0 : _g.flatMap(t => { var _a; return (_a = t.columns) !== null && _a !== void 0 ? _a : []; });
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels, inheritedByCandidates })));
    });
}
function getVirtualConnectionTableLineageLabels(_a) {
    var _b, _c, _d, _e, _f;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.VirtualConnectionTablesLineageLabelsDocument;
        const { loading, error, data } = yield queryWithUpstream(client, query, { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null });
        const upstreamLabels = (_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        const inheritedByCandidates = (_f = (_e = data.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.columns;
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels, inheritedByCandidates })));
    });
}
function getFlowLineageLabels(_a) {
    var _b, _c, _d, _e, _f;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.FlowLineageLabelsDocument;
        const { loading, error, data } = yield queryWithUpstream(client, query, { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null });
        const upstreamLabels = (_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        const inheritedByCandidates = (_f = (_e = data.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.outputFields;
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels, inheritedByCandidates })));
    });
}
function getPublishedDatasourceLineageLabels(_a) {
    var _b, _c, _d, _e, _f;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.PublishedDatasourceLineageLabelsDocument;
        const { loading, error, data } = yield queryWithUpstream(client, query, { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null });
        const upstreamLabels = (_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        const inheritedByCandidates = (_f = (_e = data === null || data === void 0 ? void 0 : data.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.fields;
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels, inheritedByCandidates })));
    });
}
function getEmbeddedDatasourceLineageLabels(_a) {
    var _b, _c, _d;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.EmbeddedDatasourceLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { id: (_b = item.contentId) !== null && _b !== void 0 ? _b : null } });
        const upstreamLabels = (_d = (_c = data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels })));
    });
}
function getViewLineageLabels(_a) {
    var _b, _c, _d;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.ViewLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { id: (_b = item.contentId) !== null && _b !== void 0 ? _b : null } });
        const upstreamLabels = (_d = (_c = data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { upstreamLabels, item })));
    });
}
function getFieldLineageLabels(_a) {
    var _b, _c, _d;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.FieldLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { id: (_b = item.contentId) !== null && _b !== void 0 ? _b : null } });
        const upstreamLabels = (_d = (_c = data.items) === null || _c === void 0 ? void 0 : _c.flatMap(f => { var _a; return (_a = f.upstreamColumns) !== null && _a !== void 0 ? _a : []; })) === null || _d === void 0 ? void 0 : _d.flatMap(f => { var _a; return (_a = f === null || f === void 0 ? void 0 : f.labels) !== null && _a !== void 0 ? _a : []; });
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels })));
    });
}
function getWorkbookLineageLabels(_a) {
    var _b, _c, _d, _e, _f, _g;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.WorkbookLineageLabelsDocument;
        const { loading, error, data } = yield queryWithUpstream(client, query, { luid: (_b = item.contentLuid) !== null && _b !== void 0 ? _b : null });
        const upstreamLabels = (_d = (_c = data === null || data === void 0 ? void 0 : data.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.upstreamLabels;
        const inheritedByCandidates = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.embeddedDatasources) === null || _g === void 0 ? void 0 : _g.flatMap(t => { var _a; return (_a = t.fields) !== null && _a !== void 0 ? _a : []; });
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels, inheritedByCandidates })));
    });
}
function getFlowFieldLineageLabels(_a) {
    var _b;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.FlowFieldLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { id: (_b = item.contentId) !== null && _b !== void 0 ? _b : '' } });
        const upstreamLabels = data.items.map(f => f.field).flatMap(f => { var _a; return (_a = f === null || f === void 0 ? void 0 : f.upstreamColumns) !== null && _a !== void 0 ? _a : []; }).flatMap(c => { var _a; return (_a = c === null || c === void 0 ? void 0 : c.labels) !== null && _a !== void 0 ? _a : []; });
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { item, upstreamLabels })));
    });
}
function getFlowColumnFieldLineageLabels(_a) {
    var _b, _c, _d;
    var { client, item } = _a, rest = tslib_1.__rest(_a, ["client", "item"]);
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const query = catalog_queries_1.FlowColumnFieldLineageLabelsDocument;
        const { loading, error, data } = yield client.query({ query, variables: { id: (_b = item.contentId) !== null && _b !== void 0 ? _b : '' } });
        const upstreamLabels = [
            ...((_c = data === null || data === void 0 ? void 0 : data.items.flatMap(of => { var _a, _b; return (_b = (_a = of.column) === null || _a === void 0 ? void 0 : _a.labels) !== null && _b !== void 0 ? _b : []; })) !== null && _c !== void 0 ? _c : []),
            ...((_d = data === null || data === void 0 ? void 0 : data.items.flatMap(of => { var _a, _b; return (_b = (_a = of.column) === null || _a === void 0 ? void 0 : _a.upstreamColumns) !== null && _b !== void 0 ? _b : []; }).flatMap(c => { var _a; return (_a = c === null || c === void 0 ? void 0 : c.labels) !== null && _a !== void 0 ? _a : []; })) !== null && _d !== void 0 ? _d : []),
        ];
        return Object.assign({ loading,
            error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)(Object.assign(Object.assign({}, rest), { upstreamLabels, item })));
    });
}
//# sourceMappingURL=getLabelsGraph.js.map